import { useQuery } from '@tanstack/react-query';
import { axiosInstance } from '@/modules/shared/lib/axios';
import { MINUTE_IN_MS } from '@/modules/shared/constants/time';
import { CountryModel } from '@/modules/shared/types/country';

type Props = {
  companyId: string
}

/**
 * Fetches available currencies.
 */
export function useQueryCurrencies({ companyId }: Props) {
  return useQuery<CountryModel[]>({
    queryKey: ['config.currencies', companyId],
    queryFn: async () => {
      // @TODO remove companyId from queryKey and endpoint when backend is fixed
      const { data } = await axiosInstance.get(`/api/${companyId}/businesstrip/currencies`);
      return data;
    },
    staleTime: MINUTE_IN_MS * 5, // cache for 5 minutes
  });
}
